import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Box,  Heading, Text} from "rebass";
import PopupForm from "../../components/Modals/PopupForm";
import {SubcategoryCard, VerticalScroll} from "./styles";

const ConfigTabPanel = props => {
	const {handleSubmit, form, items, title} = props;
	return (
		<Box>
			{items &&
			<Fragment>
				<Box width={1} p={2} pb={3} pl={3}>
					<Heading>Active {title} ({items.filter(item => item.activated).length})</Heading>
					<VerticalScroll py={1}>
							{items.filter(item => item.activated).map((item, key) => {
								return (
									<Box
										key={key}
										width={[1, 1, 1 /2 , 1 / 3]}	
										p={'10px'}
									>
										<PopupForm
											key={item.id} 
											FormComponent={form}
											handleSubmit={handleSubmit}
											initialValues={item}
											ShowComponent={(props) => (
												<SubcategoryCard {...props}>
													<Heading as={'h5'} lineHeight={1}>
														{item.is_oncampus ? 'ON - ' : 'OFF - '}{item.name}
													</Heading>
													<Text color={'meta'}>Click to configure</Text>
												</SubcategoryCard>
											)}
										/>
									</Box>
								)
							})}
					</VerticalScroll>
				</Box>

				<Box width={1} p={2} pb={3} pl={3}>
					<Heading>Inactive {title} ({items.filter(item => !item.activated).length})</Heading>
					<VerticalScroll py={1}>
							{items.filter(item => !item.activated).map((item, key) => {
								return (
									<Box
										width={[1, 1, 1 /2 , 1 / 3]}
										p={'10px'}
										key={key}
									>
										<PopupForm
											key={item.id}
											FormComponent={form}
											handleSubmit={(handleSubmit)}
											initialValues={item}
											ShowComponent={(props) => (
												<SubcategoryCard {...props}>
													<Heading as={'h5'} color={'meta'} lineHeight={1}>
														{item.is_oncampus ? 'ON - ' : 'OFF - '}{item.name}
													</Heading>
													<Text color={'meta'}>Click to configure</Text>
												</SubcategoryCard>
											)}
										/>
									</Box>
								)
							})}
					</VerticalScroll>
				</Box>
			</Fragment>
			}
		</Box>
	);
};

ConfigTabPanel.propTypes = {
	handleSubmit: PropTypes.func,
	form: PropTypes.element,
	items: PropTypes.array,
	title: PropTypes.string
};

export default ConfigTabPanel;
